import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import VTabBarlayout from "./layout/VTabBarLayout";

import { SESenderBeneficiary } from "./pages/SESenderBeneficiary";
import { SEDetails } from "./pages/SEDetails";
import { SEConditions } from "./pages/SEConditions";
import { SESummary } from "./pages/SESummary";

// import { IFQuotationSelection } from "./pages/IFQuotationSelection";

import QualityAssurancePage from "./pages/QualityAssurance";

// Logistics pages
import Initiate from "./pages/Logistics/Initiate";
import CargoDetails from "./pages/Logistics/CargoDetails";
import Quotes from "./pages/Logistics/Quotes";
import Summary from "./pages/Logistics/Summary";
// import { Dashboard } from './pages/DashboardQuotationStatus';

// import { QuotationStatus } from "./pages/QuotaionStatus";

import { InsuranceDetails } from "./pages/InsuranceDetails";
import { InsurancePolicyHolder } from "./pages/InsurancePolicyHolder";

import DashboardRequestQuote from "./pages/DashboardRequestQuote";
import DashboardReviewSubmit from "./pages/DashboardReviewSubmit";

import FullRegistrationPage from "./pages/FullRegistrationPage";
// import SimpleRegistrationPage from "./pages/SimpleRegistration";
import Dashboard from "./pages/Dashboard";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";

// import { useAppContext } from "./context/AppContext";
import { SimplePaymentLayout } from "./layout/SimplePaymentLayout";
import { SmartEscrowLayout } from "./layout/SmartEscrowLayout";
import { InvoiceFactoringLayout } from "./layout/InvoiceFactoringLayout";
import { LogisticsLayout } from "./layout/LogisticsLayout";
import { QualityAssuranceLayout } from "./layout/QualityAssuranceLayout";
import { InsuranceLayout } from "./layout/InsuranceLayout";
import { LandingPage } from "./pages/LandingPage";
import ErrorPage from "./pages/ErrorPage";

import CookieService from "./context/cookies";
import VerifyEmailPage from "./pages/VerifyEmailPage";

import ScrollToTop from "./components/ScrollToTop";
import Security from "./pages/Security";
import DashboardInsights from "./pages/DashboardInsights";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import { QualityAssuranceSummary } from "./pages/QualityAssuranceSummary";
import { InsuranceSummary } from "./pages/InsuranceSummary";
import HelpAndSupport from "./pages/HelpAndSupport";
import QualityAssuranceForm from "./components/QualityAssurance/QualityAssuranceForm";

import TradingInfo from "./pages/TradingInfo";

import AdminLogin from "./pages/Admin/AdminLogin";
import AdminDashboard, { BuyerList } from "./pages/Admin/AdminDashboard";
import BuyerDetails from "./pages/Admin/BuyerDetails";
import LoginPage from "./pages/LoginPage";
import LoginSignupLayout from "./layout/LoginSignupLayout";
import SignupPage from "./pages/SignupPage";
import AdminPanelLayout from "./layout/AdminPanelLayout";

import VendorPage from "./pages/Admin/VendorPage";

import AdminTasks from "./pages/Admin/AdminTasks";
import AdminQuotes from "./pages/Admin/AdminQuotes";
import CustomerProfiles from "./pages/Admin/CustomerProfiles";
import CustomerProfileDetails from "./pages/Admin/CustomerProfileDetails";
import CustomerHistoryDetails from "./pages/Admin/CustomerHistoryDetails";
import UploadPage from "./pages/UploadPage";
import TransactionSummary from "./pages/TransactionSummary";
import { useAppContext } from "./context/AppContext";
import XFlowFullRegistration from "./pages/XFlowFullRegistration";

import XFlowReceivables from "./pages/XFlowPayment/XFlowReceivables";

import XFlowPaymentLayout from "./layout/XFlowPaymentLayout";
import PaymentInitiate from "./components/XFlowPayment/FormSteps/Initiate";
import ReceivableAndPartners from "./pages/XFlowPayment/ReceivableAndPartners";
import DealTrackerLayout from "./layout/DealTrackerLayout";
import UploadTradeDocuments from "./pages/UploadTradeDocuments";
import AssignContacts from "./pages/AssignContacts";

import CustomQutoesLayout from "./layout/CustomQutoesLayout";
import Messages from "./pages/Messages";
import AdminInvoices from "./pages/Admin/AdminInvoices";
import AdminAccountOverview from "./pages/Admin/AdminAccountOverview";
import CustomerQuotesDetails from "./pages/Admin/CustomerQuotesDetails";
import AdminCustomerProfileLayout from "./layout/AdminCustomerProfileLayout";

// Investor
import InvestorDashboard from "./pages/Investor/InvestorDashboard";
import InvestorPanelLayout from "./layout/InvestorPanelLayout";
import PoolSummary from "./pages/Investor/PoolSummary";
import FundedDeals from "./pages/Investor/FundedDeals";
import InvestorDetails from "./pages/Investor/InvestorDetails";
import RFQs from "./pages/Admin/AdminRFQs";
import OngoingOrders from "./components/Admin/OngingOrders";
import AdminRFQs from "./pages/Admin/AdminRFQs";
import CustomerRFQsDetails from "./pages/Admin/CustomerRFQsDetails";
import CustomerOngoingQuotesDetails from "./pages/Admin/CustomerOngoingQuotesDetails";

import {
  ProtectedRoute,
  ProtectedAdminRoute,
  RoleRoute,
  PublicRoute,
} from "./components/CustomRoute";
import Procurement from "./pages/Procurement";
import HomeNew from "./pages/HomeNew";
import WhatsAppDocUpload from "./pages/WhatsAppDocUpload";

// const router = createBrowserRouter(createRoutesFromElements());

function App() {
  const { xFlow } = useAppContext();

  return (
    <Router basename="/">
      <ScrollToTop />

      <Routes>
        {/* <Route path="/" element={<LandingPage />} /> */}
        <Route path="/" element={<HomeNew />} />

        <Route
          path="/"
          element={
            <PublicRoute element={<LoginSignupLayout />} redirectTo="/" />
          }
        >
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignupPage />} />
        </Route>

        {/* User routes */}
        <Route
          path="/"
          element={
            <ProtectedRoute
              element={
                <RoleRoute allowedRoles={["user"]}>
                  <VTabBarlayout />
                </RoleRoute>
              }
              redirectTo="/"
            />
          }
        >
          <Route
            path="simple-payment"
            element={xFlow ? <XFlowPaymentLayout /> : <SimplePaymentLayout />}
          >
            <Route index element={<PaymentInitiate />} />
            <Route path="receivable" element={<ReceivableAndPartners />} />
            <Route path="partner" element={<XFlowReceivables />} />
          </Route>

          <Route path="smart-escrow" element={<SmartEscrowLayout />}>
            <Route index element={<Navigate to={"sender-beneficiary"} />} />

            <Route
              path="sender-beneficiary"
              element={<SESenderBeneficiary />}
            />
            <Route path="details" element={<SEDetails />} />
            <Route path="conditions" element={<SEConditions />} />
            <Route path="summary" element={<SESummary />} />
          </Route>

          <Route
            path="invoice-factoring"
            element={<InvoiceFactoringLayout />}
          />

          <Route path="logistics" element={<LogisticsLayout />}>
            {/* <Route index element={<Navigate to={"cargo-details"} />} /> */}

            <Route index element={<Initiate />} />
            <Route path="cargo-details" element={<CargoDetails />} />
            <Route path="quotes" element={<Quotes />} />
            <Route path="summary" element={<Summary />} />
          </Route>

          <Route path="quality-assurance" element={<QualityAssuranceLayout />}>
            <Route index element={<QualityAssuranceForm />} />
            <Route path="summary" element={<QualityAssuranceSummary />} />
          </Route>

          <Route path="insurance" element={<InsuranceLayout />}>
            <Route index element={<Navigate to={"policy-holder"} />} />

            <Route path="policy-holder" element={<InsurancePolicyHolder />} />
            <Route path="details" element={<InsuranceDetails />} />
            <Route path="summary" element={<InsuranceSummary />} />
          </Route>

          <Route path="request-a-quote" element={<DashboardRequestQuote />} />
          <Route path="transaction-summary" element={<TransactionSummary />} />
          <Route path="review-submit" element={<DashboardReviewSubmit />} />

          <Route path="dashboard" element={<Dashboard />} />
          <Route path="dashboard/insights" element={<DashboardInsights />} />
          <Route path="deal-tracker" element={<DealTrackerLayout />} />
          <Route path="procurement" element={<Procurement />} />

          <Route path="security" element={<Security />} />

          <Route
            path="registration"
            element={
              xFlow ? <XFlowFullRegistration /> : <FullRegistrationPage />
            }
          />
          <Route path="help-and-support" element={<HelpAndSupport />} />
          <Route path="/messages" element={<Messages />} />
        </Route>

        <Route path="verify-email" element={<VerifyEmailPage />} />
        <Route path="forgot-password" element={<ForgotPassword />} />
        <Route path="reset-password" element={<ResetPassword />} />

        <Route path="trading-info" element={<TradingInfo />} />
        <Route path="upload" element={<UploadPage />} />
        <Route
          path="upload-trade-documents"
          element={<UploadTradeDocuments />}
        />
        <Route path="assign-trade-documents" element={<AssignContacts />} />
        <Route path="vendor-form" element={<CustomQutoesLayout />} />
        <Route
          path="whatsapp-document-upload"
          element={<WhatsAppDocUpload />}
        />

        {/* Investor routes */}
        <Route
          path="/investor"
          element={
            <ProtectedRoute
              element={
                <RoleRoute allowedRoles={["investor"]}>
                  <InvestorPanelLayout />
                </RoleRoute>
              }
              redirectTo="/"
            />
          }
        >
          <Route index path="dashboard" element={<InvestorDashboard />} />
          <Route path="pool-summary" element={<PoolSummary />} />
          <Route path="investor-details/:id" element={<InvestorDetails />} />
          <Route path="funded-deals" element={<FundedDeals />} />
          <Route path="help-and-support" element={<HelpAndSupport />} />
        </Route>

        {/* Admin routes */}
        <Route path="admin">
          <Route path="login" element={<AdminLogin />} />
          <Route
            element={
              <ProtectedAdminRoute
                element={<AdminPanelLayout />}
                redirectTo="/admin/login"
              />
            }
          >
            <Route index path="dashboard" element={<AdminDashboard />} />
            <Route path="tasks" element={<AdminTasks />} />
            <Route path="quotes" element={<AdminQuotes />} />
            <Route path="rfqs" element={<AdminRFQs />} />

            <Route path="ongoing-orders" element={<OngoingOrders />} />
            <Route path="vendors" element={<VendorPage />} />

            <Route path="customer-profiles">
              <Route index element={<CustomerProfiles />} />

              <Route element={<AdminCustomerProfileLayout />}>
                <Route path=":uid" element={<CustomerProfileDetails />} />
                <Route path=":uid/rfqs/:id" element={<CustomerRFQsDetails />} />
                <Route
                  path=":uid/quotes/:id"
                  element={<CustomerQuotesDetails />}
                />
                <Route
                  path=":uid/ongoing-quotes/:id"
                  element={<CustomerOngoingQuotesDetails />}
                />

                <Route
                  path=":uid/history/:id"
                  element={<CustomerHistoryDetails />}
                />
              </Route>
            </Route>
            <Route path="invoices">
              <Route index element={<AdminInvoices />} />
            </Route>
            <Route path="account-overview">
              <Route index element={<AdminAccountOverview />} />
            </Route>
            <Route path="buyer" element={<BuyerList />} />
            <Route path="buyer/:id" element={<BuyerDetails />} />
          </Route>
        </Route>
        <Route path="*" element={<ErrorPage />} />
      </Routes>

      <ToastContainer />
    </Router>
  );
}

export default App;
